import InteractionsHeader from "./components/interaction-header";
import AddLink from "./components/addLink";
import InteractionsOptions from "./components/interactionsOptions";
import InteractionMain from "./components/interactionMain";
import InteractionsSaved from "./components/interactionsSaved";
import InteractionMedia from "./components/interactionMedia";
import InteractionShop from "./components/interactionShop";
import SettingsScreen from "./components/settingsScreen";
import { useEffect, useState } from "react";
import useAppAccessor from "../../hooks/useappAccessor";
import "./style.css";
import { showSettingPage } from "../agora-live/components/streamControls/controls.actions";
import ShopSite from "./components/shopSite";
import ShopifyInteraction from "./components/interactionShopify";
import InteractionTranont from "./components/interactionTranont";
import InteractionPartnerCo from "./components/interactionPartnerCo";
const Interactions = () => {
  const { getControls, getUserData } = useAppAccessor();
  const { isShowSettings } = getControls();
  const { user } = getUserData();
  const { publicUserData } = user;
  const [isShowMainView, setIsShowMainView] = useState(true);
  const [isOptions, setIsOptions] = useState(false);
  const [isshowLinkScreen, setIsshowLinkScreen] = useState(false);
  const [isshowSavedInteraction, setIsshowSavedInteraction] = useState(false);
  const [isshowInteractionMedia, setIsshowInteractionMedia] = useState(false);
  const [isshowInteractionShopify, setIsshowInteractionShopify] =
    useState(false);
  const [isshowInteractionShop, setIsshowInteractionShop] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);

  function handleOpenModal() {
    setIsOpenModal(!isOpenModal);
  }

  useEffect(() => {}, [user]);
  const handleOptionClickCondiion = (type: any) => {
    switch (type) {
      case "A":
        setIsShowMainView(false);
        setIsshowSavedInteraction(false);
        setIsshowLinkScreen(false);
        setIsshowInteractionMedia(false);
        setIsshowInteractionShopify(true);
        setIsshowInteractionShop(true);
        setIsOptions(false);

        break;
      case "B":
        setIsShowMainView(false);
        // setIsOptions(false)
        setIsshowSavedInteraction(false);
        setIsshowLinkScreen(false);
        setIsshowInteractionShop(false);
        setIsshowInteractionMedia(true);
        setIsshowInteractionShopify(false);

        break;
      case "C":
        setIsShowMainView(false);
        setIsOptions(false);
        setIsshowSavedInteraction(false);
        setIsshowInteractionMedia(false);
        setIsshowInteractionShop(false);
        setIsshowLinkScreen(true);
        setIsshowInteractionShopify(false);

        break;
      case "D":
        setIsShowMainView(false);
        setIsOptions(false);
        setIsshowLinkScreen(false);
        setIsshowInteractionMedia(false);
        setIsshowInteractionShop(false);
        setIsshowSavedInteraction(true);
        setIsshowInteractionShopify(false);

        break;

      default:
        break;
    }
  };

  useEffect(() => {
    console.log("[DEUBG] Company Name", publicUserData?.company_name)
  }, []);
  return (
    <div className="flex h-full w-full ">
      {!isShowSettings && (
        <>
          {isShowMainView && (
            <>
              <div className="flex-col h-full w-full max-h-[100%]">
                {window.location.href.indexOf("/stream") > -1 && (
                  <InteractionsHeader
                    handleShowOptionsClick={() => {
                      setIsShowMainView(false);
                      setIsshowSavedInteraction(false);
                      setIsshowInteractionMedia(false);
                      setIsshowInteractionShopify(false);
                      setIsOptions(true);
                    }}
                  ></InteractionsHeader>
                )}
                <div
                  id="dragContainer"
                  className={
                    window.location.href.indexOf("/stream") > -1
                      ? "dragMainContainer"
                      : "dragMainContainerAttendee"
                  }
                >
                  <InteractionMain></InteractionMain>
                </div>
              </div>
            </>
          )}
          {isOptions && (
            <InteractionsOptions
              handleCloseclick={() => {
                setIsShowMainView(true);
                setIsshowSavedInteraction(false);
                setIsshowInteractionMedia(false);
                setIsshowInteractionShopify(false);
                setIsshowInteractionShop(false);
                setIsOptions(false);
              }}
              handleOptionsClick={(e: any) => {
                handleOptionClickCondiion(e);
              }}
            ></InteractionsOptions>
          )}
          {isshowLinkScreen && (
            <AddLink
              handleCloseClick={(flag: any) => {
                setIsShowMainView(false);
                setIsshowLinkScreen(false);
                setIsshowSavedInteraction(false);
                setIsshowInteractionMedia(false);
                setIsshowInteractionShopify(false);
                setIsshowInteractionShop(false);
                setIsOptions(true);
                if (flag) {
                  setIsOptions(false);
                  setIsShowMainView(true);
                }
              }}
            ></AddLink>
          )}

          {isshowSavedInteraction && (
            <InteractionsSaved
              handleCloseClick={() => {
                setIsShowMainView(false);
                setIsshowLinkScreen(false);
                setIsshowSavedInteraction(false);
                setIsshowInteractionShop(false);
                setIsshowInteractionShopify(false);
                setIsOptions(true);
              }}
            ></InteractionsSaved>
          )}

          {isshowInteractionMedia && (
            <InteractionMedia
              modalIsOpen={isshowInteractionMedia}
              handleCloseMediaInteraction={(flag: any) => {
                setIsShowMainView(false);
                setIsshowLinkScreen(false);
                setIsshowSavedInteraction(false);
                setIsshowInteractionMedia(false);
                setIsshowInteractionShop(false);
                setIsshowInteractionShopify(false);
                setIsOptions(true);
                if (flag) {
                  setIsOptions(false);
                  setIsShowMainView(true);
                }
              }}
            ></InteractionMedia>
          )}

          {isshowInteractionShop &&
            publicUserData?.company_name === "partner.co" && (
              <InteractionPartnerCo
                modalIsOpen={isshowInteractionShop}
                handleCloseMediaInteraction={(flag: any) => {
                  setIsShowMainView(false);
                  setIsshowLinkScreen(false);
                  setIsshowSavedInteraction(false);
                  setIsshowInteractionMedia(false);
                  setIsshowInteractionShop(false);
                  setIsshowInteractionShopify(false);
                  setIsOpenModal(false);
                  setIsOptions(true);
                  if (flag) {
                    setIsOptions(false);
                    setIsShowMainView(true);
                  }
                }}
              ></InteractionPartnerCo>
            )}

          {isshowInteractionShop &&
            publicUserData.store_type !== "shopify" &&
            publicUserData?.company_name !== "tranont" &&
            publicUserData?.company_name !== "partner.co" && (
              <ShopSite
                handleOpenModal={handleOpenModal}
                handleCloseClick={() => {
                  setIsShowMainView(false);
                  setIsshowLinkScreen(false);
                  setIsshowSavedInteraction(false);
                  setIsshowInteractionMedia(false);
                  setIsshowInteractionShopify(false);
                  setIsshowInteractionShop(false);
                  setIsOptions(true);
                }}
              ></ShopSite>
            )}

          {isshowInteractionShop &&
            publicUserData.store_type === "shopify" &&
            publicUserData?.company_name !== "tranont" &&
            publicUserData?.company_name !== "partner.co" && (
              <ShopifyInteraction
                modalIsOpen={isshowInteractionShopify}
                handleCloseMediaInteraction={(flag: any) => {
                  setIsShowMainView(false);
                  setIsshowLinkScreen(false);
                  setIsshowSavedInteraction(false);
                  setIsshowInteractionMedia(false);
                  setIsshowInteractionShop(false);
                  setIsOptions(true);
                  if (flag) {
                    setIsOptions(false);
                    setIsShowMainView(true);
                  }
                }}
              ></ShopifyInteraction>
            )}

          {isshowInteractionShop &&
            publicUserData?.company_name === "tranont" &&
            (publicUserData?.locale === "en_CA" ||
            publicUserData?.locale === "fr_CA" ? (
              <ShopSite
                handleOpenModal={handleOpenModal}
                handleCloseClick={() => {
                  setIsShowMainView(false);
                  setIsshowLinkScreen(false);
                  setIsshowSavedInteraction(false);
                  setIsshowInteractionMedia(false);
                  setIsshowInteractionShopify(false);
                  setIsshowInteractionShop(false);
                  setIsOptions(true);
                }}
              ></ShopSite>
            ) : (
              <InteractionTranont
                modalIsOpen={isshowInteractionShop}
                handleCloseMediaInteraction={(flag: any) => {
                  setIsShowMainView(false);
                  setIsshowLinkScreen(false);
                  setIsshowSavedInteraction(false);
                  setIsshowInteractionMedia(false);
                  setIsshowInteractionShop(false);
                  setIsshowInteractionShopify(false);
                  setIsOpenModal(false);
                  setIsOptions(true);
                  if (flag) {
                    setIsOptions(false);
                    setIsShowMainView(true);
                  }
                }}
              ></InteractionTranont>
            ))}

          {isOpenModal && publicUserData?.company_name === "tranont" && (
            <InteractionTranont
              modalIsOpen={isshowInteractionShop}
              handleCloseMediaInteraction={(flag: any) => {
                setIsShowMainView(false);
                setIsshowLinkScreen(false);
                setIsshowSavedInteraction(false);
                setIsshowInteractionMedia(false);
                setIsshowInteractionShop(false);
                setIsshowInteractionShopify(false);
                setIsOpenModal(false);
                setIsOptions(true);
                if (flag) {
                  setIsOptions(false);
                  setIsShowMainView(true);
                }
              }}
            ></InteractionTranont>
          )}

          {isOpenModal && publicUserData?.company_name !== "tranont" && (
            <InteractionShop
              modalIsOpen={isOpenModal}
              handleCloseMediaInteraction={(flag: any) => {
                setIsShowMainView(false);
                setIsshowLinkScreen(false);
                setIsshowSavedInteraction(false);
                setIsshowInteractionMedia(false);
                setIsshowInteractionShop(false);
                setIsshowInteractionShopify(false);
                setIsOpenModal(false);
                setIsOptions(true);
                if (flag) {
                  setIsOptions(false);
                  setIsShowMainView(true);
                }
              }}
            ></InteractionShop>
          )}
        </>
      )}

      {isShowSettings && (
        <div className="settingContainerMain">
          <SettingsScreen></SettingsScreen>
        </div>
      )}
    </div>
  );
};

export default Interactions;
